import { extendObservable, computed } from 'mobx'
import find from 'lodash/find'

import { segmentApi } from '@atheneum/api'

import Segment from '@models/Segment.model'

class SegmentStore {
  constructor (growlStore) {
    extendObservable(this, {
      growlStore,
      segments: [],
      loading: false,
      isEmpty: computed(() => {
        return !this.loading && this.segments.length === 0
      })
    })
  }

  getAll (projectId) {
    this.loading = true
    return segmentApi
      .getByProject(projectId)
      .then(segments => {
        this.segments = segments.map(i => new Segment(i))
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        throw err
      })
  }

  statusChange (id, val) {
    const segment = find(this.segments, s => s.id === id)
    segment.complete = val
    return segmentApi.complete(id, val)
  }

  get (id) {
    return segmentApi.getOne(id).then(segment => {
      return new Segment(segment)
    })
  }

  orderDown (id) {
    return segmentApi
      .orderDown(id)
      .then(() => {
        this.growlStore.showSuccess('Segment successfully reordered')
      })
      .catch(error => {
        this.growlStore.showError(error, 'Unable to reorder segment')
      })
  }

  orderUp (id) {
    return segmentApi
      .orderUp(id)
      .then(() => {
        this.growlStore.showSuccess('Segment successfully reordered')
      })
      .catch(error => {
        this.growlStore.showError(error, 'Unable to reorder segment')
      })
  }

  addEmployee (id, employeeId) {
    return segmentApi
      .addEmployee(id, employeeId)
      .then(() => {
        this.growlStore.showSuccess('You have been assigned to this segment')
      })
      .catch(error => {
        this.growlStore.showError(error)
      })
  }

  remove (id) {
    return segmentApi
      .deleteSegment(id)
      .catch(error => this.growlStore.showError(error))
  }
}

export default SegmentStore
